var _module_exports ="<div class=\"breadcrumbs-wrapper is-60\" gov-breadcrumb></div>";;
var path = '/app/Main/grcEdit/businessPlan/initiative/initiativeBreadcrumbs.tpl.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;